/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import BannerImage from '../components/BannerImage';
import BannerTitle from '../components/BannerTitle';
import LinkWrapper from '../components/LinkWrapper';
import AbstractLayout from './AbstractLayout';

export default class ImageOnly extends AbstractLayout {
	get key() {
		return 'image_only';
	}

	content() {
		const { banner, ignoreTitle } = this.attrs;

		// We need to show the title here,
		// for legacy support of the old banner layout
		const legacy = banner.setup().legacy === true;
		let hasTitle;
		if (legacy) {
			hasTitle = !!banner.content()?.title?.default;
		}

		return (
			<div className={`Banner-content ${legacy ? `legacy ${hasTitle ? 'hasTitle' : ''}` : ''}`}>
				{!ignoreTitle && <BannerTitle banner={banner} />}
				<LinkWrapper banner={banner}>
					<BannerImage banner={banner} />
				</LinkWrapper>
			</div>
		);
	}
}
